/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Cmspage_Error_Target_Story1Inputs */

const vi_cmspage_error_target_story1 = /** @type {(inputs: Cmspage_Error_Target_Story1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Câu chuyện "${i?.slug}" chưa đăng hoặc không tồn tại — đăng câu chuyện trước rồi gắn vào nhóm.`)
};

/**

* @param {Cmspage_Error_Target_Story1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_error_target_story1 = /** @type {((inputs: Cmspage_Error_Target_Story1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Error_Target_Story1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_error_target_story1(inputs)
});
export { cmspage_error_target_story1 as "cmsPage_error_target_story" }